import createCrudService from '@core/api/create-crud-service';

import type { TDynamicFilter } from '@shared/types/dynamic-filter';
import type { TField } from '@shared/types/field';

export type TDynamicFilterQuery = {
  page_number?: number;
  page_size?: number;
  field?: number;
  type?: TField['type'];
  operator?: TDynamicFilter['operator'];
};

type TDynamicFilterPayload = {
  field: number;
  type: TField['type'];
  operator: TDynamicFilter['operator'];
  name?: string;
  value: string[];
};

const dynamicFilterApi = createCrudService<
  TDynamicFilter,
  TDynamicFilterQuery,
  TDynamicFilterPayload
>({
  queryKey: ['dynamic-filters'],
  url: 'answer-filters',
});

export default dynamicFilterApi;
